import { YhPageHeader } from '@src/components/YhPageHeader'
import { ISearchField, SearchTypeEnum } from '@src/components/YhPageHeader/Types'
import { useDsModel } from '@src/model/dsModel'
import { StatusDs } from '@src/types/FmsDs'
import React from 'react'
import { useVehicleModle } from '../vehicleModel'

export function PageHeader() {
  const { vehicleTypeDs, vehicleBrandDs } = useDsModel()
  const { onSearch, onReset, updateSearchParam, searchParam } = useVehicleModle()
  const searchFields: ISearchField[] = [
    {
      type: SearchTypeEnum.Input,
      xxl: 4,
      span: 4,
      placeholder: '车辆编号',
      fieldName: 'vehicleCode',
      size: "small",
    },
    {
      type: SearchTypeEnum.Select,
      xxl: 4,
      span: 4,
      placeholder: '车辆类型',
      fieldName: 'typeCode',
      size: 'small',
      options: vehicleTypeDs
    },
    {
      type: SearchTypeEnum.Select,
      xxl: 4,
      span: 4,
      placeholder: '品牌型号',
      fieldName: 'modelCode',
      size: 'small',
      options: vehicleBrandDs
    },
    // {
    //   type: SearchTypeEnum.Select,
    //   xxl: 4,
    //   span: 4,
    //   placeholder: '状态',
    //   fieldName: 'status',
    //   size: 'small',
    //   options: StatusDs
    // },
    {
      type: SearchTypeEnum.Datepicker,
      xxl: 4,
      span: 4,
      placeholder: '创建时间',
      fieldName: 'createTime',
      format: "YYYY-MM-DD",
      size: "small",
    },
  ]
  return (
    <div>
      <YhPageHeader
        title="基础数据/车俩管理"
        onChange={updateSearchParam}
        handleReset={onReset}
        handleSearch={onSearch}
        searchFields={searchFields}
        searchValues={searchParam}
      />
    </div>
  )
}